<section class="section-white">
  <div class="section-container-inside">
    <div class="section-trustpilot-container">
      <div class="paystack-heading">
        <div [innerHtml]="_storyData?.quoteText | toHtml"></div>
        <div class="revolutionize-team-description mar-t-24">
          {{ _storyData?.name }}, {{ _storyData?.designation }}
        </div>
      </div>
      <div class="trustpilot-separator"></div>
      <div class="trustpilot-customer-logo">
        <h1
          class="trustpilot-big grey-800 uppsecase"
          [innerHtml]="_storyData?.achievement | toHtml"
        ></h1>
        <h3 class="revolutionize-team-heading">
          {{ _storyData?.achievementTitle }}
        </h3>
        <figure>
          <img
            src="{{ _storyData?.imageUrl }}"
            alt="Workpay"
            class="customer-logo"
          />
        </figure>
      </div>
    </div>
  </div>
</section>
<app-trust-pilot
  [bgWhite]="true"
  [paddTop]="true"
></app-trust-pilot>